var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.956 3A8.983 8.983 0 0 0 4.86 6.462 8.976 8.976 0 0 0 3.39 9.23a.75.75 0 0 1-1.428-.462A10.476 10.476 0 0 1 3.68 5.54 10.483 10.483 0 0 1 11.956 1.5c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5a10.467 10.467 0 0 1-7.27-2.923l1.04-1.083A8.967 8.967 0 0 0 11.955 21a9 9 0 0 0 0-18Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.206 6h1.5v5.69l3.53 3.53-1.06 1.06-3.97-3.97V6ZM0 6.276l1.412-.508 1.268 3.53 3.529-1.269.507 1.412-4.94 1.775L0 6.276Z",
    fill: "#080707"
  })));
};
export default SvgHistory;